import configureTokens, { getTokens } from "./tokens";
import configureFonts from "./fonts";
var configure = function configure(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$app = _ref.app,
    app = _ref$app === void 0 ? "itau" : _ref$app,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "varejo" : _ref$variant,
    _ref$originFonts = _ref.originFonts,
    originFonts = _ref$originFonts === void 0 ? "extern" : _ref$originFonts,
    _ref$assetsPathFonts = _ref.assetsPathFonts,
    assetsPathFonts = _ref$assetsPathFonts === void 0 ? "" : _ref$assetsPathFonts,
    _ref$setStyleVariable = _ref.setStyleVariablesInHTML,
    setStyleVariablesInHTML = _ref$setStyleVariable === void 0 ? true : _ref$setStyleVariable,
    _ref$fonts = _ref.fonts,
    fonts = _ref$fonts === void 0 ? {
      ItauText: [300, 400, 700, 900],
      ItauDisplay: [300, 700, 900]
    } : _ref$fonts;
  if (setStyleVariablesInHTML) {
    configureTokens({
      app: app,
      variant: variant
    }).then(function () {
      console.log("%c @ds-itau - tokens loaded", "color: #EC7000");
    });
  }
  configureFonts({
    fonts: fonts,
    assetsPathFonts: assetsPathFonts,
    originFonts: originFonts
  }).then(function () {
    console.log("%c @ds-itau - fonts loaded", "color: #EC7000");
  });
};
export { getTokens };
export default configure;